import { render, staticRenderFns } from "./SupplierPerformanceView.vue?vue&type=template&id=1916dacc&scoped=true"
import script from "./SupplierPerformanceView.vue?vue&type=script&lang=js"
export * from "./SupplierPerformanceView.vue?vue&type=script&lang=js"
import style0 from "./SupplierPerformanceView.vue?vue&type=style&index=0&id=1916dacc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1916dacc",
  null
  
)

export default component.exports